import styled from '@emotion/styled';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  margin: 30px;
  min-width: 600px;
`;

export const CardTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
`;

export const CardSubtitle = styled.div`
  font-size: 13px;
  color: #888;
  font-weight: 400;
`;
